module.exports = __webpack_public_path__ + "ab4552f1714d8a0f791367b666dc4344.svg";